import React from "react";
import StarRating from "./StarRating";
import BotService from "../services/botService";
import { Inputs } from "../types/chatbot.types";

interface AdaptiveCardProps {
	content: any;
	index: number;
	inputs: Inputs;
	setInputs: React.Dispatch<React.SetStateAction<Inputs>>;
	rate: number;
	setRate: React.Dispatch<React.SetStateAction<number>>;
	botServiceRef: React.MutableRefObject<BotService | null>;
	socketRef: React.MutableRefObject<WebSocket | null>;
	setLoading: React.Dispatch<React.SetStateAction<boolean>>;
	openWebSocket: (streamUrl: string) => void;
}

const AdaptiveCard: React.FC<AdaptiveCardProps> = ({
	content,
	index,
	inputs,
	setInputs,
	rate,
	setRate,
	botServiceRef,
	socketRef,
	setLoading,
	openWebSocket,
}) => {
	const SubmitHandler = async (event: React.FormEvent) => {
		event.preventDefault();
		setLoading(true);

		// check if the socket connection is closed then open it
		if (socketRef.current?.readyState === WebSocket.CLOSED) {
			console.log("socket connection closed now opening");
			const rss = await botServiceRef.current?.getStreamUrl();

			if (rss && rss.streamUrl) {
				openWebSocket(rss.streamUrl);
			}
		}

		if (botServiceRef?.current === null || botServiceRef?.current === undefined)
			return;

		const sentValue = await botServiceRef.current?.sendFormData({
			...inputs,
			actionSubmitId: "Submit",
		});
		
		//after sending the form data clear the inputs
		setInputs({});
		

		setLoading(false);
	};

	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const name = event.target.name;
		const value = event.target.value;
		setInputs((values) => ({ ...values, [name]: value }));
	};

	return (
		<div>
			<div className="line"></div>
			<form onSubmit={SubmitHandler} className="hero-card" key={index}>
				{content.body.map((item: any, idx: number) => {
					if (item.type === "Input.Text") {
						return (
							<div className="formitem" key={idx}>
								<label className="formlabel">{item.label}</label>
								<input
									className="forminput"
									required={item.isRequired}
									id={item.id}
									name={item.id}
									value={inputs?.[item.id] ?? ""}
									onChange={handleChange}
									placeholder={item.placeholder}
								></input>
							</div>
						);
					} else if (item.type === "ActionSet") {
						return (
							<div key={idx}>
								<button className="formsubmit" type="submit">
									{item.actions[0].title}
								</button>
							</div>
						);
					} else if (item.type === "TextBlock") {
						return (
							<div key={idx}>
								<p className="TextBlock">{item.text}</p>
							</div>
						);
					} else if (item.type === "Input.Date") {
						return (
							<div className="formitem" key={idx}>
								<label className="formlabelwithbottomborder">
									{item.label}
								</label>
								<input
									className="forminputwithbottomborder"
									name={item.id}
									value={inputs?.[item.id] ?? ""}
									//value={inputs ? inputs[item.id] : ""}
									onChange={handleChange}
									required={item.isRequired}
									id={item.id}
									type={item.type}
								></input>
							</div>
						);
					} else if (item.type === "Input.ChoiceSet") {
						return (
							<div className="formitem" key={idx}>
								{item.choices.map((res: any, choiceIdx: number) => (
									<div className="d-flex" key={choiceIdx}>
										<label className="formlabelwithbottomborder">
											<input
												className="forminputwithbottomborder"
												name={item.id}
												value={res.value}
												required={item.isRequired}
												type="radio"
												onChange={handleChange}
											/>
											{res.title}
										</label>
									</div>
								))}
							</div>
						);
					} else if (item.type === "ColumnSet") {
						return (
							<StarRating
								rate={rate}
								setRate={setRate}
								setInputs={setInputs}
								idx={idx}
								item={item}
								submitHandler={(e) => {
									SubmitHandler(e);
									botServiceRef?.current?.startEndConversationWithType(
										"endConversation"
									);
								}}
								values={inputs}
							/>
						);
					}
					return null;
				})}
				<div>
					<button className="formsubmit" type="submit">
						Submit
					</button>
				</div>
			</form>
		</div>
	);
};

export default AdaptiveCard;
